export type ToolGap = "site" | "business" | "capability" | null;

export type ToolGapInput = {
  readonly sitesLoaded: boolean;
  readonly activeSite: { readonly businessInfo: string } | null;
  readonly capabilityReady: boolean;
};

export type ToolGapResult =
  | { readonly status: "loading" }
  | { readonly status: "ready"; readonly gap: ToolGap };

/**
 * 工具可读性：Site → business → Capability，一次只暴露第一层。
 * 无站点且无 API 时只返回 "site"，禁止跳层把人送去设置。
 */
export function resolveToolGap(input: ToolGapInput): ToolGapResult {
  if (!input.sitesLoaded) {
    return { status: "loading" };
  }
  if (!input.activeSite) {
    return { status: "ready", gap: "site" };
  }
  if (!input.activeSite.businessInfo.trim()) {
    return { status: "ready", gap: "business" };
  }
  if (!input.capabilityReady) {
    return { status: "ready", gap: "capability" };
  }
  return { status: "ready", gap: null };
}
